import { FormProvider } from 'context/FormContext';
import { usePermissionsContext } from 'context/PermissionsContext';
import { ConfiguracaoMinimoFormComp } from 'pages/compra/configuracao-minimo/components';

export function ConfiguracaoMinimoForm() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();

    if (!hasPermission(['COMPRA_PEDIDO_CONFIGURACAO_VISUALIZAR'])) return alertNotPermission();

    return (
        <FormProvider>
            <ConfiguracaoMinimoFormComp />
        </FormProvider>
    );
}
